import { TokenContext } from '@cibo/core'

export const createYearTokenContext = (year?: number): TokenContext | undefined => {
  if (typeof year !== 'number' || Number.isNaN(year)) {
    return undefined
  }

  return {
    get: name => {
      if (name === 'year') {
        return year
      }

      return undefined
    },
  }
}

/**
 * Deep-clones a JSON schema, applying a string replacer to every string value
 * (e.g. field `title`s). Used to expand `{{copyToken}}` values before the
 * schema reaches `CiboAutoForm` / `EffectiveSchemaBridge`.
 */
export function applyReplacerToSchema(schema: any, replacer: (s: string) => string): any {
  if (!schema || typeof schema !== 'object') return schema
  if (Array.isArray(schema)) return schema.map(item => applyReplacerToSchema(item, replacer))
  return Object.fromEntries(
    Object.entries(schema).map(([key, value]) => [
      key,
      typeof value === 'string' ? replacer(value) : applyReplacerToSchema(value, replacer),
    ])
  )
}